// XAVIER - New file
var base = require('settings/teams/update-team-header');

Vue.component('spark-update-team-header', {
    mixins: [base],
});
